import { Stack } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { TournamentDetailPage } from '../../features/tournament';
import { tournamentBeforeLoad } from '../../features/tournament/lib/tournament-route-guard.ts';
import { createPageBackgroundSx } from '../../styles/pageBackground.ts';

export const Route = createFileRoute('/tournaments/$slug')({
  component: RouteComponent,
  beforeLoad: tournamentBeforeLoad,
});

const tournamentDetailPageSx = createPageBackgroundSx();

function RouteComponent() {
  const { slug } = Route.useParams();

  return (
    <Stack sx={tournamentDetailPageSx}>
      <TournamentDetailPage slug={slug} />
    </Stack>
  );
}
